import { useEffect } from "react";

import { useRootLoaderData } from "~/root";

import { installSegmentDataLayerInterceptor } from "./data-layer-interceptor";

/**
 * Installs the SFRA -> Segment `segmentDataLayer` replay interceptor once, on the
 * client, near app root (SFCC-11725). Rendered inside <ClientOnly> alongside the
 * rest of the Segment suite so it never runs SSR.
 *
 * Gated on a Segment write key (FSA/HSA only): WDH has no write key, so no
 * `window.analytics` is ever created and there is nothing to replay into —
 * patching `window.fetch` there would be pure overhead. The interceptor itself
 * still guards every replay on `window.analytics` being present, so consent /
 * TPA gating is inherited from <Segment />'s SDK init (see
 * `data-layer-interceptor.ts`).
 */
export const SegmentDataLayerInterceptor = () => {
  const { segmentWriteKey } = useRootLoaderData();

  useEffect(() => {
    if (!segmentWriteKey) return;
    installSegmentDataLayerInterceptor();
  }, [segmentWriteKey]);

  return null;
};
